;(function() {
  'use strict'

  controller.$inject = ["$scope", "glDialog"];
  angular.module('core.cardReward').controller('CardReward', controller)

  /* @ngInject */
  function controller($scope, glDialog) {
    $scope.view = view
    $scope.backgroundStyle = backgroundStyle

    function view() {
      // console.log('vew(reward)', reward);
      glDialog.alert(
        'Get Glowfeed',
        'Download the Glowfeed app to view, redeem and take your rewards with you!'
      )
    }

    function backgroundStyle(url) {
      return {
        'background-image': 'url(' + url + ')',
      }
    }
  }
})()
